import Validator from './Validator';

/* global FormValidation */

export default function validateUpdateApplicationStatus(form) {
  function getTimeDate(timeString) {
    const [endHour, endMinute] = timeString.split(':');

    const now = new Date();

    return new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      Number(endHour),
      Number(endMinute),
      0,
    );
  }

  return Validator.create(
    form,
    {
      interviewDate: {
        validators: {
          notEmpty: {
            message: 'Datum ist ein Pflichtfeld',
          },
          date: {
            format: 'DD.MM.YYYY',
            message: 'Bitte ein Datum in der Form "27.07.2023" eingeben',
          },
        },
      },
      interviewStartTime: {
        validators: {
          notEmpty: {
            message: 'Start ist ein Pflichtfeld',
          },
          regexp: {
            regexp: /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/,
            message: 'Bitte ein Uhrzeit in der Form "19:15" eingeben',
          },
          callback: {
            message: 'Interview Start muss früher als Ende sein',
            callback: input => {
              const start = getTimeDate(form.querySelector('[name="interviewStartTime"]').value);
              const end = getTimeDate(form.querySelector('[name="interviewEndTime"]').value);
              const startTime = start.getTime();
              const endTime = end.getTime();

              if (isNaN(startTime) || isNaN(endTime)) {
                return true;
              }

              return startTime < endTime;
            },
          },
        },
      },
      interviewEndTime: {
        validators: {
          notEmpty: {
            message: 'Ende ist ein Pflichtfeld',
          },
          regexp: {
            regexp: /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/,
            message: 'Bitte ein Uhrzeit in der Form "19:15" eingeben',
          },
          callback: {
            message: 'Interview Ende muss später als Start sein',
            callback: input => {
              const start = getTimeDate(form.querySelector('[name="interviewStartTime"]').value);
              const end = getTimeDate(form.querySelector('[name="interviewEndTime"]').value);
              const startTime = start.getTime();
              const endTime = end.getTime();

              if (isNaN(startTime) || isNaN(endTime)) {
                return true;
              }

              return startTime < endTime;
            },
          },
        },
      },
      subject: {
        validators: {
          notEmpty: {
            message: 'Betreff ist ein Pflichtfeld',
          },
        },
      },
      message: {
        validators: {
          notEmpty: {
            message: 'Nachricht ist ein Pflichtfeld',
          },
        },
      },
    },
    {
      excluded: new FormValidation.plugins.Excluded({
        // NOTE: exclude speculativeApplicationText and speculativeApplicationSuccessMessage validation
        // if speculativeApplicationActive checkbox has not been checked
        excluded: field =>
          (field === 'subject' || field === 'message') &&
          !form.querySelector('.send-mail-radio[value="yes"]').checked,
      }),
    },
  );
}
